import {
  BoxGeometry,
  MeshPhongMaterial,
  MeshBasicMaterial,
  Mesh,
  TextGeometry,
  BufferGeometry,
} from "three";
import { defaultFontOptions } from "./../helpers/fonts.js";

export default class ArrayItem {
  constructor() {
    this._items = [];
  }

  getItems() {
    return this._items;
  }

  create(matrixWorld, character, index) {
    this.matrixWorld = matrixWorld;
    this.character = character;
    this.index = index;

    const cube = this._drawCube();
    const letter = this._drawLetter();
    const arrayIndex = this._drawArrayIndex();

    return { cube, letter, arrayIndex };
  }

  _drawCube() {
    const geometry = new BoxGeometry(0.1, 0.1, 0.03);
    const material = new MeshPhongMaterial({
      color: 0x616161,
      wireframe: false,
    });

    const cube = new Mesh(geometry, material);
    cube.userData = { type: "array_item", index: this.index };

    cube.position
      .set(this.index * 0.11, 0, -0.3)
      .applyMatrix4(this.matrixWorld);
    cube.quaternion.setFromRotationMatrix(this.matrixWorld);
    cube.cursor = "pointer";
    this._items.push(cube);
    return cube;
  }

  _getSizeFromLength(string) {
    const values = {
      1: 0.05,
      2: 0.04,
      3: 0.03,
      4: 0.025,
      5: 0.02,
    };
    if (string.length >= 1 && string.length <= 5) {
      return values[string.length];
    }

    return 0.018;
  }

  _textEllpisis(string) {
    if (string.length <= 5) {
      return string;
    }

    return string.substring(0, 5) + "...";
  }

  _getLetterXPosition(string) {
    const lowerCaseNumber = [...string].reduce((total, character) => {
      if (/[a-z]/.test(character)) {
        return total + 1;
      }
      return total;
    }, 0);

    const lowerCaseOffset = lowerCaseNumber * 0.002;

    if (string.length === 1) {
      return this.index * 0.1078 - 0.018 + lowerCaseOffset;
    }
    if (string.length === 2) {
      return this.index * 0.1078 - 0.014 * 2 + lowerCaseOffset;
    }
    if (string.length === 3) {
      return this.index * 0.1078 - 0.011 * 3 + lowerCaseOffset;
    }
    if (string.length === 4) {
      return this.index * 0.1078 - 0.0105 * 4 + lowerCaseOffset;
    }
    if (string.length === 5) {
      return this.index * 0.1078 - 0.0085 * 5 + lowerCaseOffset;
    }
    if (string.length > 5) {
      return this.index * 0.1078 - 0.006 * 7 + lowerCaseOffset;
    }
  }

  _getLetterYPosition(string) {
    if (string.length === 1) {
      return -0.025;
    }
    if (string.length === 2) {
      return -0.02;
    }
    if (string.length === 3) {
      return -0.015;
    }
    if (string.length === 4) {
      return -0.013;
    }
    if (string.length === 5) {
      return -0.01;
    }
    if (string.length > 5) {
      return -0.01;
    }
  }

  _getLetterColor(stringCharacters) {
    if (["true", "false"].includes(stringCharacters)) {
      return 0x6cd9ee;
    }

    return 0xffffff;
  }

  _drawLetter() {
    const stringCharacters = this.character.toString();
    const fontGeometry = new TextGeometry(
      this._textEllpisis(stringCharacters),
      {
        ...defaultFontOptions,
        ...{
          size: this._getSizeFromLength(stringCharacters),
          bevelThickness: 2,
        },
      }
    );
    const textGeo = new BufferGeometry().fromGeometry(fontGeometry);

    const textMaterial = new MeshBasicMaterial({
      color: this._getLetterColor(stringCharacters),
    });

    const letter = new Mesh(textGeo, textMaterial);

    letter.rotation.x = 0;
    letter.rotation.y = Math.PI * 2;

    letter.position
      .set(
        this._getLetterXPosition(stringCharacters),
        this._getLetterYPosition(stringCharacters),
        -0.28
      )
      .applyMatrix4(this.matrixWorld);
    letter.quaternion.setFromRotationMatrix(this.matrixWorld);

    return letter;
  }

  _drawArrayIndex() {
    const indexMaterial = new MeshBasicMaterial({
      color: 0x616161,
    });
    const indexGeometry = new TextGeometry(this.index.toString(), {
      ...defaultFontOptions,
      ...{
        size: 0.03,
        bevelThickness: 0.01,
      },
    });
    const indexGeo = new BufferGeometry().fromGeometry(indexGeometry);

    const arrayIndex = new Mesh(indexGeo, indexMaterial);

    arrayIndex.rotation.x = 0;
    arrayIndex.rotation.y = Math.PI * 2;

    arrayIndex.position
      .set(this.index * 0.108, -0.1, -0.3)
      .applyMatrix4(this.matrixWorld);
    arrayIndex.quaternion.setFromRotationMatrix(this.matrixWorld);
    return arrayIndex;
  }
}
